<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="admin-level-log-table-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <!-- 搜索栏 -->
        <div
          class="search-bar"
          style="
            margin-bottom: 20px;
            display: flex;
            gap: 10px;
            align-items: center;
            flex-wrap: wrap;
          "
        >
          <el-input
            v-model="searchParams.user_id"
            placeholder="请输入用户ID"
            clearable
            style="width: 180px"
          ></el-input>

          <el-button type="primary" @click="getList">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </div>

        <!-- 表格 -->
        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%"
          @row-click="handleRowClick"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column
            label="用户ID"
            prop="user_id"
            width="120"
            align="center"
          />
          <el-table-column label="变动成长值" prop="grow_value" width="120" align="center">
            <template slot-scope="scope">
              <span style="color: #67c23a; font-weight: bold">
                +{{ scope.row.grow_value }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="变动前成长值" prop="old_grow_value" width="130" align="center" />
          <el-table-column label="变动后成长值" prop="new_grow_value" width="130" align="center" />
          
          <el-table-column label="原等级" prop="level_id" width="100" align="center" />
          <el-table-column label="新等级" prop="new_level_id" width="100" align="center" />
          <el-table-column label="类型" prop="type" width="100" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.type == 1 ? '订单增加' : '其他' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="订单ID" prop="order_id" width="120" align="center" />
          <el-table-column label="创建时间" prop="created_at" width="180" />
        </el-table>

        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- 详情弹窗 -->
        <el-dialog
          title="等级成长记录详情"
          :visible.sync="detailVisible"
          width="700px"
          append-to-body
        >
          <el-form :model="detailForm" label-width="140px" size="small">
            <el-form-item label="记录ID"><span>{{ detailForm.id }}</span></el-form-item>
            <el-form-item label="用户ID"><span>{{ detailForm.user_id }}</span></el-form-item>
            <el-form-item label="变动成长值">
              <span style="color: #67c23a; font-weight: bold">
                +{{ detailForm.grow_value }}
              </span>
            </el-form-item>
            <el-form-item label="变动前成长值"><span>{{ detailForm.old_grow_value }}</span></el-form-item>
            <el-form-item label="变动后成长值"><span>{{ detailForm.new_grow_value }}</span></el-form-item>
            <el-form-item label="原等级"><span>{{ detailForm.level_id }}</span></el-form-item>
            <el-form-item label="新等级"><span>{{ detailForm.new_level_id }}</span></el-form-item>
            <el-form-item label="记录类型">
              <span>{{ detailForm.type == 1 ? '订单增加' : '其他' }}</span>
            </el-form-item>
            <el-form-item label="订单ID"><span>{{ detailForm.order_id || '-' }}</span></el-form-item>
            <el-form-item label="创建时间"><span>{{ detailForm.created_at }}</span></el-form-item>
          </el-form>
          <div slot="footer" style="text-align: right">
            <el-button @click="detailVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-log-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <!-- 搜索栏 -->
        <div class="mobile-search-group">
          <el-input
            v-model="searchParams.user_id"
            placeholder="用户ID"
            clearable
            size="medium"
            prefix-icon="el-icon-user"
          />

          <div style="display: flex; gap: 8px; margin-top: 10px">
            <el-button type="primary" plain round @click="getList" style="flex: 1">搜索</el-button>
            <el-button plain round @click="resetSearch" style="flex: 1">重置</el-button>
          </div>
        </div>

        <!-- 卡片列表 -->
        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="openMobileDetail(item)"
          >
            <div class="card-top">
              <div class="id-info">
                <span>记录ID：{{ item.id }}</span>
                <span class="type-tag">{{ item.type == 1 ? '订单增加' : '其他' }}</span>
              </div>
              <div class="amount add">+{{ item.grow_value }}</div>
            </div>

            <div class="card-middle">
              <div>用户ID：{{ item.user_id }}</div>
              <div>原等级：{{ item.level_id }} → 新等级：{{ item.new_level_id }}</div>
              <div>成长值：{{ item.old_grow_value }} → {{ item.new_grow_value }}</div>
            </div>

            <div class="card-bottom">
              <div class="time">{{ item.created_at }}</div>
              <div class="remark" v-if="item.order_id">订单ID：{{ item.order_id }}</div>
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="total"
            pager-count="2"
            small
          />
        </div>

        <!-- 移动端详情弹窗 -->
        <el-dialog
          title="记录详情"
          :visible.sync="mobileDetailVisible"
          width="95%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form
            v-if="mobileDetailRow"
            :model="mobileDetailRow"
            label-width="110px"
            size="small"
          >
            <el-form-item label="记录ID">{{ mobileDetailRow.id }}</el-form-item>
            <el-form-item label="用户ID">{{ mobileDetailRow.user_id }}</el-form-item>
            <el-form-item label="变动成长值">
              <span style="color: #67c23a; font-weight: bold">+{{ mobileDetailRow.grow_value }}</span>
            </el-form-item>
            <el-form-item label="变动前成长值">{{ mobileDetailRow.old_grow_value }}</el-form-item>
            <el-form-item label="变动后成长值">{{ mobileDetailRow.new_grow_value }}</el-form-item>
            <el-form-item label="原等级">{{ mobileDetailRow.level_id }}</el-form-item>
            <el-form-item label="新等级">{{ mobileDetailRow.new_level_id }}</el-form-item>
            <el-form-item label="类型">{{ mobileDetailRow.type == 1 ? '订单增加' : '其他' }}</el-form-item>
            <el-form-item label="订单ID">{{ mobileDetailRow.order_id || '-' }}</el-form-item>
            <el-form-item label="创建时间">{{ mobileDetailRow.created_at }}</el-form-item>
          </el-form>

          <div slot="footer" style="text-align: right">
            <el-button @click="mobileDetailVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";

export default {
  name: "AdminUserLevelLogList",
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      searchParams: {
        page: 1,
        page_size: 10,
        user_id: "",
      },
      // PC详情弹窗
      detailVisible: false,
      detailForm: {},
      // 移动端详情
      mobileDetailVisible: false,
      mobileDetailRow: null,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取用户等级成长记录
    async getList() {
      this.loading = true;
      try {
        const res = await api.logs.userLevelLog({
          params: this.searchParams,
        });
        if (res.data.code == 1000) {
          this.tableData = res.data.data.data;
          this.total = res.data.data.total;
        }
      } finally {
        this.loading = false;
      }
    },

    // PC查看详情
    handleRowClick(row) {
      this.detailForm = { ...row };
      this.detailVisible = true;
    },

    // 移动端打开详情
    openMobileDetail(row) {
      this.mobileDetailRow = JSON.parse(JSON.stringify(row));
      this.mobileDetailVisible = true;
    },

    // 重置搜索
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        user_id: "",
      };
      this.getList();
    },

    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
  },
};
</script>

<style scoped>
/* ====================== PC 原有样式 ====================== */
.admin-level-log-table-container {
  padding: 20px;
}

/* ====================== 移动端样式 ====================== */
.mobile-log-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  cursor: pointer;
}
.card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.id-info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}
.type-tag {
  background: #f5f7fa;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  color: #666;
}
.amount {
  font-weight: bold;
  font-size: 16px;
}
.amount.add {
  color: #67c23a;
}
.card-middle {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 8px;
}
.card-bottom {
  font-size: 12px;
  color: #999;
  line-height: 1.5;
  padding-top: 8px;
  border-top: 1px dashed #f0f0f0;
}
</style>


// WEBPACK FOOTER //
// src/pages/log/userLevelLog.vue